import React from 'react';
import { EnvironmentInfo } from '~/components';
import screenRegister from '~/hoc/screenRegister';
import LogoMT from '~/ui/assets/imgs/mt-logo.svg';
import LogoSmall from '~/ui/assets/imgs/Tponto.png';
import OfficeBanner from '~/ui/assets/imgs/office-banner.jpg';
import {
  Container,
  Banner,
  BannerImage,
  LogoPosition,
  Main,
  MainContent,
  ContentWrapper,
  LogoWrapper,
} from './Login.styled';
import { LoginForm } from './Form';

function Login() {
  return (
    <Container>
      <Banner>
        <BannerImage alt="meutudo" height={817} src={OfficeBanner} width={498} />

        <LogoPosition>
          <LogoMT className="fill-black md:fill-white" />
        </LogoPosition>
      </Banner>

      <Main>
        <MainContent>
          <ContentWrapper>
            <LogoWrapper src={LogoSmall} alt="Logo" />
            <LoginForm />
          </ContentWrapper>
        </MainContent>
      </Main>
      <EnvironmentInfo removeButton />
    </Container>
  );
}

export default screenRegister({
  screenName: 'Login',
  headerTitle: 'Login',
})(Login);
